import React, { useState, useEffect, useMemo } from 'react'
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import ReactDataTableBootstrap from '../../Components/ReactDataTableBootstrap/ReactDataTableBootstrap';
import Controllers from '../../Api/Controllers';
import SaleTrackerForm from './SaleTrackerForm'
import { toast } from 'react-toastify';
import Helpers from '../../Components/Helpers/Helpers';
import SweetAlert from '../../Components/SweetAlert/SweetAlert'
import FormCustom from '../../Components/Form/FormCustom';
import Input from '../../Components/Form/Input';
import { useSelector } from 'react-redux';

const SaleTracker = ({ nameSingle, namePlural, separator }) => {
    const [isProcessing, setIsProccesing] = useState(false)
    const [modalShow, setModalShow] = useState(false);
    const [modalTitle, setModalTitle] = useState('');
    const [rows, setRows] = useState([])
    const [loadSubmit, setLoadSubmit] = useState(false)
    const [dataUpdated, setDataUpdated] = useState({})
    const [showConfirmDelete, setShowConfirmDelete] = useState(false)
    const [loadSubmitDelete, setLoadSubmitDelete] = useState(false)
    const [dataDeleted, setDataDeleted] = useState({})

    const permissions = useSelector(store => store.session.permissions)
    const actionsModule = Helpers.getActions({ permissions, module: 'guias-de-rastreo' })

    const [dataFilter, setDataFilter] = useState({
        p_date_start: '',
        p_date_end: ''
    })

    const getData = _ => {
        setIsProccesing(true)
        Controllers.sale_tracker.get_sale_tracker(dataFilter).then(res => {
            setRows(res.data)
        }).catch(req => Helpers.promise.catch({ req, toast }))
            .finally(() => {
                setIsProccesing(false)
            })
    }

    useEffect(() => {
        getData()
    }, [])

    const handleInsertUpdate = ({ data }) => {
        setLoadSubmit(true)
        Controllers.sale_tracker.sale_tracker_insert_update(data).then(res => {
            Helpers.toast.construct({ ...res, toast })
            if (res.response === 'success') {
                setModalShow(false)
                setDataUpdated({})
            }
        }).catch(req => Helpers.promise.catch({ req, toast }))
            .finally(() => {
                setLoadSubmit(false)
                getData()
            })
    }

    const handleGet = e => {
        let $this = e.currentTarget

        if (!$this.dataset?.idSale) {
            setModalTitle(`Registrar ${nameSingle}`)
            setDataUpdated({})
            setModalShow(true);
            return
        }

        let buttonHTML = $this.innerHTML;
        $this.innerHTML = '<i class="fa fa-circle-notch fa-spin"></i>'
        let { idSale } = $this.dataset

        Controllers.sale_tracker.get_sale_tracker_id({ p_id_sale: idSale }).then(res => {
            setModalTitle(`Modificar ${nameSingle} #${idSale}`)
            setDataUpdated({ data: res.data })
            setModalShow(true);
        }).catch(req => {
            Helpers.promise.catch({ req, toast })
            getData()
        })
            .finally(() => $this.innerHTML = buttonHTML)
    }

    const handleDelete = () => {
        setLoadSubmitDelete(true)

        Controllers.sale_tracker.sale_tracker_delete(dataDeleted).then(res => {
            Helpers.toast.construct({ ...res, toast })
            if (res.response === 'success') {
                setShowConfirmDelete(false)
                setDataDeleted({})
            }
        }).catch(req => Helpers.promise.catch({ req, toast }))
            .finally(() => {
                getData()
                setLoadSubmitDelete(false)
            })
    }

    const handleHideModalForm = () => {
        setModalShow(false)
        setLoadSubmit(false)
    }

    const handleShowModalDelete = e => {
        let { idSale, nameSale } = e.currentTarget.dataset
        setDataDeleted({
            p_id_sale: idSale,
            p_name_sale: nameSale
        })
        setShowConfirmDelete(true)
    }

    const handleHideModalDelete = () => setShowConfirmDelete(false)

    const dtRows = useMemo(() => <ReactDataTableBootstrap
        head={[
            [
                { name: 'id_sale', text: 'ID Venta', align: 'center' },
                { name: 'id_customers', text: 'ID Cliente', align: 'center' },
                { name: 'full_name_customers', text: 'Nombres', align: 'center' },
                { name: 'provider_name', text: 'Paquetería', align: 'center' },
                { name: 'guide_number', text: 'Número Guía', align: 'center' },
                { name: 'send_date', text: 'Fecha Envío', align: 'center' },
                { name: 'status_dispatch', text: 'Estado', align: 'center', render: r => <strong>{r.status_dispatch}</strong> },
                { name: 'user_created', text: 'Usuario', align: 'center' },
                {
                    name: 'actions', text: <i className="fa fa-cog"></i>, align: 'center', render: u => {
                        return <div>
                            {actionsModule?.update &&                             <Button variant="info" className="mr-1" size="xs" data-id-sale={u.id_sale} onClick={handleGet}>
                                <i className="fa fa-edit"></i>
                            </Button>}
                            {actionsModule.delete && <Button variant="danger" size="xs" data-id-sale={u.id_sale} data-name-sale={u.name_sale} onClick={handleShowModalDelete}>
                                <i className="fa fa-trash"></i>
                            </Button>}
                        </div>
                    }
                },
            ],
        ]}
        rows={rows}
        isProcessing={isProcessing}
    />, [rows, isProcessing, actionsModule?.update, actionsModule.delete])

    return <>
        <Card>
            <Card.Header className="justify-content-between">
                <span>Listado De {namePlural}</span>
                {actionsModule?.new && <Button size="sm" onClick={handleGet}>
                    <i className="fa fa-plus mr-1"></i> Registrar {nameSingle}
                </Button>}
            </Card.Header>
            <Card.Body>
                <FormCustom viewSubmit={false} className="mb-3" onSubmit={_ => {
                    getData()
                }}>
                    <Input
                        classNameParent="col-md-6 col-md-4 mb-2"
                        icon="far fa-calendar"
                        placeholder="Fecha Inicio"
                        text="Fecha Inicio"
                        onChange={e => setDataFilter({ ...dataFilter, p_date_start: e.currentTarget.value })}
                        required
                        type="date"
                    />
                    <Input
                        classNameParent="col-md-6 col-md-4 mb-2"
                        icon="far fa-calendar"
                        placeholder="Fecha Fina"
                        text="Fecha Fina"
                        onChange={e => setDataFilter({ ...dataFilter, p_date_end: e.currentTarget.value })}
                        append={[<Button type="submit">
                            <i className="fa fa-search mr-2"></i>Buscar
                        </Button>]}
                        required
                        type="date"
                    />
                </FormCustom>
                {dtRows}
            </Card.Body>
        </Card>
        <Modal show={modalShow} onHide={handleHideModalForm} backdrop="static">
            <Modal.Header closeButton>
                <Modal.Title as="div">{modalTitle}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <SaleTrackerForm onSubmit={handleInsertUpdate} loadSubmit={loadSubmit} {...dataUpdated} />
            </Modal.Body>
        </Modal>
        <SweetAlert
            icon="delete"
            show={showConfirmDelete}
            showCancelButton
            title={<>¿Desea eliminar {separator} {nameSingle}?</>}
            subtitle={<>#{dataDeleted.p_id_sale} - {dataDeleted.p_name_sale}</>}
            confirmButtonText="¡Sí, eliminar!"
            cancelButtonText="¡No!"
            loadSubmit={loadSubmitDelete}
            onCancel={handleHideModalDelete}
            onConfirm={handleDelete}
        />
    </>
}

export default SaleTracker